import Swiper from "swiper";
import { Navigation, Thumbs, Pagination } from "swiper/modules";

$(function () {
	let historyYearSlider = new Swiper(".history-year-slider .swiper", {
		modules: [Navigation],
		slidesPerView: 5,
		spaceBetween: 20,
		// loop: true,
		watchSlidesProgress: true,
		slideToClickedSlide: true,
	});
	let historyContentSlider = new Swiper(".history-content-slider .swiper", {
		modules: [Navigation, Thumbs],
		slidesPerView: 1.25,
		spaceBetween: 16,
		// loop: true,
		centeredSlides: true,
		thumbs: {
			swiper: historyYearSlider,
		},
		navigation: {
			nextEl: ".history-year-slider .swiper-btn-next",
			prevEl: ".history-year-slider .swiper-btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 2.25,
				spaceBetween: 32,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 32,
			},
		},
	});

	let facilitySlider = new Swiper(".facility-slider .swiper", {
		modules: [Navigation, Pagination],
		slidesPerView: 1.25,
		spaceBetween: 20,
		loop: true,
		centeredSlides: true,
		pagination: {
			el: ".facility-slider .swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".facility-slider .swiper-btn-next",
			prevEl: ".facility-slider .swiper-btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 1.11627907,
				spaceBetween: 40,
			},
		},
	});

	let departmentSlider = new Swiper(".department-slider .swiper", {
		slidesPerView: 1,
		spaceBetween: 20,
		loop: true,
	});
	$(".department-slider .next-btn").on("click", function () {
		departmentSlider.slideNext();
	});
});
